// Helpers de data — evita o bug de timezone (YYYY-MM-DD sendo tratado como UTC
// e mostrando um dia a menos em fusos negativos como o Brasil UTC-3).

/**
 * Formata data pura (YYYY-MM-DD) para pt-BR (dd/mm/aaaa) sem sofrer com timezone.
 * Se a string já tiver hora/ISO com timezone, usa Intl normalmente.
 * Retorna "—" para valores vazios/nulos.
 */
export function formatBRDate(value) {
  if (!value) return "—";
  const s = String(value).trim();

  // Caso "YYYY-MM-DD" puro: split manual — nada de new Date() aqui.
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (m) {
    return `${m[3]}/${m[2]}/${m[1]}`;
  }

  // Caso "YYYY-MM-DDTHH:MM..." (ISO com hora): pega só a parte da data e formata.
  const iso = s.match(/^(\d{4})-(\d{2})-(\d{2})T/);
  if (iso) {
    return `${iso[3]}/${iso[2]}/${iso[1]}`;
  }

  // Fallback — string em outros formatos
  const d = new Date(s);
  if (Number.isNaN(d.getTime())) return s;
  return d.toLocaleDateString("pt-BR");
}

/**
 * Formata data curta com mês abreviado (ex.: 05/jun) sem timezone shift.
 */
export function formatBRDateShort(value) {
  if (!value) return "—";
  const s = String(value).trim();
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!m) {
    const d = new Date(s);
    if (Number.isNaN(d.getTime())) return s;
    return d.toLocaleDateString("pt-BR", { day: "2-digit", month: "short" });
  }
  const meses = ["jan", "fev", "mar", "abr", "mai", "jun", "jul", "ago", "set", "out", "nov", "dez"];
  return `${m[3]}/${meses[parseInt(m[2], 10) - 1]}`;
}
